import { Command, HttpMethod } from "~/extensions/api";
export class GetFilesCommand extends Command {
    constructor() {
        super(HttpMethod.Post, "common/files/get");
    }
    informationNo = null;
    BuknCd = null;
    UserCd = null;
    OrgNyukyokeiyakuNo = null;
    shomeiNo = null;
    fileList = [];
}
export class GetFileItem {
    constructor(fileNo, fileFetchKb, fileCode, fileExists, fileId) {
        this.fileNo = fileNo;
        this.fileFetchKb = fileFetchKb;
        this.fileCode = fileCode;
        this.fileExists = fileExists;
        if (typeof fileId === "number") {
            this.fileId = fileId;
        }
        else if (typeof fileId === "string") {
            this.fileIdStr = fileId;
        }
    }
    fileNo = null;
    fileId = null;
    fileIdStr = null;
    fileFetchKb = null;
    fileCode = null;
    fileExists;
}
